module.exports = {"title":"404 | GoGoVan 香港","404_title":"","404_body":"ᒥ爲何人類總要重複同樣的錯誤ᒧ","404_sub":"—— 阿寶","404_links_title":"或者試試這些鏈接：","404_links_button_link_title":"愛•回家"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/404/locale.json
// module id = 614
// module chunks = 0 1 2 3 4 5